/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramUsersControllerPatchLanguageMutationRequest,
  TelegramUsersControllerPatchLanguageMutationResponse,
  TelegramUsersControllerPatchLanguage401,
} from '../types/TelegramUsersControllerPatchLanguage.ts';

function getTelegramUsersPatchLanguageUrl() {
  const res = { method: 'PATCH', url: `/api/telegram/users/language` as const };
  return res;
}

/**
 * {@link /api/telegram/users/language}
 */
export async function telegramUsersPatchLanguage(
  data: TelegramUsersControllerPatchLanguageMutationRequest,
  config: Partial<RequestConfig<TelegramUsersControllerPatchLanguageMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramUsersControllerPatchLanguageMutationResponse,
    ResponseErrorConfig<TelegramUsersControllerPatchLanguage401>,
    TelegramUsersControllerPatchLanguageMutationRequest
  >({ method: 'PATCH', url: getTelegramUsersPatchLanguageUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
